import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowDown"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0002 21.5178L4.48242 14L6.25019 12.2322L10.7502 16.7322V3H13.2502V16.7322L17.7502 12.2322L19.518 14L12.0002 21.5178Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDown;
